import { withTrailingSlash } from 'ufo';

export default function ({ path, query, hash }: any) {
  if (path === '/' || path.endsWith('/')) {
    return;
  }

  return navigateTo({ path: withTrailingSlash(path), query, hash }, { redirectCode: 301 });
}
